// Presentation helpers only. Access and the material section remain server-owned.
const collator = new Intl.Collator('ru', {numeric: true, sensitivity: 'base'});

export function materialSize(size) {
  if (typeof size !== 'number' || !Number.isFinite(size) || size < 0) return 'Размер неизвестен';
  const units = ['Б', 'КБ', 'МБ', 'ГБ'];
  let value = size, unit = 0;
  while (value >= 1024 && unit < units.length - 1) {value /= 1024; unit += 1;}
  return `${value.toLocaleString('ru-RU', {maximumFractionDigits: unit ? 1 : 0})} ${units[unit]}`;
}

export function visibleMaterials(items, query = '', ordering = 'name') {
  const search = query.trim().normalize('NFKC').toLocaleLowerCase('ru');
  return (Array.isArray(items) ? items : []).filter(node =>
    !search || String(node.name || '').normalize('NFKC').toLocaleLowerCase('ru').includes(search))
    .slice().sort((left, right) => {
      const folders = Number(right.kind === 'folder') - Number(left.kind === 'folder');
      if (folders) return folders;
      if (ordering === 'size') {
        const bySize = (Number(right.size) || 0) - (Number(left.size) || 0);
        if (bySize) return bySize;
      }
      return collator.compare(String(left.name || ''), String(right.name || ''))
        || String(left.id).localeCompare(String(right.id));
    });
}

export function canDownloadMaterial(node, rights = []) {
  return Boolean(node && rights.includes('download') && (!node.rights || node.rights.includes('download')));
}

export function selectionState(nodes, selected) {
  const ids = new Set(selected);
  const count = nodes.filter(node => ids.has(node.id)).length;
  return {all: nodes.length > 0 && count === nodes.length, partial: count > 0 && count < nodes.length};
}

export function planPreview(node) {
  return /(?:план|черт[её]ж|схем|обмер|лист|floor.?plan|drawing)/i.test(node.name || '');
}


export function materialType(node) {
  return String(node?.name || '').match(/\.([a-z0-9]{1,12})$/i)?.[1].toUpperCase() || 'Файл';
}

// A folder listing never proves totals for the entire project or its readiness.
export function materialSummary(items = []) {
  const nodes = Array.isArray(items) ? items : [];
  const files = nodes.filter(node => node.kind === 'file');
  const folders = nodes.filter(node => node.kind === 'folder').length;
  const countLabel = (count, forms) => {
    const mod100 = count % 100, mod10 = count % 10;
    return `${count} ${forms[mod100 > 10 && mod100 < 20 ? 2 : mod10 === 1 ? 0 : mod10 > 1 && mod10 < 5 ? 1 : 2]}`;
  };
  const filesLabel = countLabel(files.length, ['файл', 'файла', 'файлов']);
  const sizeLabel = files.length && !folders && files.every(node => typeof node.size === 'number' && Number.isFinite(node.size) && node.size >= 0)
    ? materialSize(files.reduce((sum, node) => sum + node.size, 0)) : '';
  const parts = [];
  if (files.length) {
    if (sizeLabel) parts.push(sizeLabel);
    parts.push(filesLabel);
  }
  if (folders) parts.push(countLabel(folders, ['папка', 'папки', 'папок']));
  return {files: files.length, filesLabel, folders, sizeLabel, detail: parts.join(' · ') || 'Нет файлов'};
}
